import { render } from "./LicenseStatusEmailDeliverySection.vue?vue&type=template&id=77622b42&scoped=true"
import script from "./LicenseStatusEmailDeliverySection.vue?vue&type=script&lang=js"
export * from "./LicenseStatusEmailDeliverySection.vue?vue&type=script&lang=js"

import "./LicenseStatusEmailDeliverySection.vue?vue&type=style&index=0&id=77622b42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77622b42"]])

export default __exports__